/* istanbul ignore file */
// TODO: Create test file

/* eslint-disable import/prefer-default-export */
export const SET_CTA_JUMP_CLICK = 'setCtaJumpClick';
export const SET_OUTFIT_AVAILIBILITY = 'setOutfitAvailability';
